const brandColors = {
    main: '#FFFFFF',
    secondary: '#141517',
    accent: 'linear-gradient(90deg, #DFF60D 0%, #3FD600 100%)',
};

const alertColors = {
    green: '#2FBE64',
    red: '#E73E6B',
    yellow: '#FFAF12',
    blue: '#4282FF',
    purple: '#8742FF',
};

const paletteColors = {
    white: '#FFFFFF',
    background: {
        overlay: {
            green: 'linear-gradient(0deg, #2FBE6426 0%, #2FBE6426 100%), #141517',
            red: 'linear-gradient(0deg, #E73E6B26 0%, #E73E6B26 100%), #141517',
        },
    },
};

const exchange = {
    buy: '#2FBE64',
    sell: '#E73E6B',
};

const lightColors = {
    primary: '#3FD600',
    hover: 'linear-gradient(0deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 100%), #3FD600',
    brand: brandColors,
    logo: '#000000',
    text: {
        primary: '#000000',
        secondary: '#4D4A46',
        tertiary: '#999999',
        disabled: '#CCCCCC',
        accent: '#1A1A1A',
        primaryReverse: '#FFFFFF',
        secondaryReverse: '#AAAAAA',
    },
    background: {
        primary: '#FFFFFF',
        secondary: {
            v1: '#FFFFFF',
            v2: '#FFFFFF',
            v3: '#F6F6F6',
            v4: '#EAEAEA',
            v5: '#FFFFFF',
        },
        disabled: '#EBEBEB',
        accent: 'linear-gradient(90deg, #DFF60D 0%, #3FD600 100%)',
        overlay: {
            v1: '#FFFFFF',
            v2: '#FFFFFF',
            v3: '#F6F6F6',
            v4: '#EAEAEA',
            v5: 'rgba(0, 0, 0, 0.5)',
            green: '#2FBE6426',
            red: '#E73E6B26',
            yellow: '#FFAF1226',
            blue: '#4282FF26',
            purple: '#8742FF26',
        },
    },
    alert: alertColors,
    exchange: exchange,
    border: {
        light: '#EBEBEB',
        dark: '#BBBBBB',
    },
    icon: {
        default: '#EBEBEB',
    },
    palette: paletteColors,
};

const darkColors = {
    primary: '#DFF60D',
    hover: 'linear-gradient(0deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 100%), #DFF60D',
    brand: brandColors,
    logo: '#DFF60D',
    text: {
        primary: '#FFFFFF',
        secondary: '#AAAAAA',
        tertiary: '#777777',
        disabled: '#333333',
        accent: '#1A1A1A',
        primaryReverse: '#000000',
        secondaryReverse: '#4D4A46',
    },
    background: {
        primary: '#141517',
        secondary: {
            v1: '#050505',
            v2: '#141517',
            v3: '#1B1C1F',
            v4: '#26282C',
            v5: '#1B1C1F',
        },
        disabled: '#AAAAAA',
        accent: 'linear-gradient(90deg, #DFF60D 0%, #3FD600 100%)',
        overlay: {
            v1: '#050505',
            v2: '#141517',
            v3: '#1B1C1F',
            v4: '#26282C',
            v5: 'rgba(0, 0, 0, 0.5)',
            green: 'linear-gradient(0deg, #2FBE6426 0%, #2FBE6426 100%), #141517',
            red: 'linear-gradient(0deg, #E73E6B26 0%, #E73E6B26 100%), #141517',
            yellow: 'linear-gradient(0deg, #FFAF1226 0%, #FFAF1226 100%), #141517',
            blue: 'linear-gradient(0deg, #4282FF26 0%, #4282FF26 100%), #141517',
            purple: 'linear-gradient(0deg, #8742FF26 0%, #8742FF26 100%), #141517',
        },
    },
    alert: alertColors,
    exchange: exchange,
    border: {
        light: '#2A2E39',
        dark: '#404040',
    },
    icon: {
        default: '#404040',
    },
    palette: paletteColors,
};

export { lightColors, darkColors };
